import React, { useState, useEffect } from 'react';
import { Filter, Save } from 'lucide-react';
import '../styles/Dashboard.css';
import { useI18n } from '../utils/i18n';
import Modal from './ui/Modal';

const TicketFilterModal = ({ 
  isOpen, 
  onClose, 
  onSave, 
  currentSettings = {}, 
  loading = false 
}) => {
  const { t } = useI18n();
  const [filterSettings, setFilterSettings] = useState({
    ...currentSettings
  });
  
  const [keywordsList, setKeywordsList] = useState('');

  useEffect(() => {
    if (isOpen && currentSettings) {
      setFilterSettings({
        ...currentSettings
      });
      setKeywordsList(currentSettings.keywords || '');
    }
  }, [isOpen, currentSettings]);

  const handleSave = () => {
    const { showOnlyAssignedToMe, ...rest } = filterSettings || {};
    const settings = {
      ...rest,
      keywords: keywordsList
    };
    onSave(settings);
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      icon={<Filter size={24} />}
      title={t('dashboard.configureTicketFilter', 'Ticket Filter konfigurieren')}
      closeDisabled={loading}
      closeLabel={t('common.close', 'Schließen')}
      footer={(
        <>
          <button
            type="button"
            onClick={onClose}
            className="btn btn-secondary"
            disabled={loading}
          >
            {t('common.cancel', 'Abbrechen')}
          </button>
          <button
            type="button"
            onClick={handleSave}
            className="btn btn-primary"
            disabled={loading}
          >
            <Save size={16} />
            {loading ? t('common.saving', 'Speichere...') : t('common.save', 'Speichern')}
          </button>
        </>
      )}
    >
      <div className="form-body">
          {/* Removed: "Nur mir zugewiesene zeigen" toggle */}
          <div className="form-group">
            <label htmlFor="keywords-list">{t('filters.keywordFilter', 'Schlagwort-Filter')}</label>
            <textarea
              id="keywords-list"
              value={keywordsList}
              onChange={(e) => setKeywordsList(e.target.value)}
              placeholder={t('filters.keywordFilterPlaceholder', 'Ein Schlagwort pro Zeile eingeben...\nz.B.:\nBug\nFeature\nSupport')}
              rows="8"
              className="form-textarea"
              disabled={loading}
            />
            <small className="form-help">
              {t('filters.keywordFilterHelp', 'Tickets, die diese Schlagwörter im Titel, Beschreibung oder Kategorie enthalten, werden herausgefiltert. Ein Schlagwort pro Zeile eingeben.')}
            </small>
          </div>

          <div className="form-group">
            <div className="filter-preview">
              <h4>{t('filters.activeFilters', 'Aktive Filter:')}</h4>
              <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                {keywordsList.trim() && (
                  <li>
                    {t('filters.keywordsCount', '{{count}} Schlagwort(e) werden gefiltert', { count: keywordsList.split('\n').filter(k => k.trim()).length })}
                  </li>
                )}
                {!keywordsList.trim() && (
                  <li style={{ color: 'var(--color-text-placeholder)' }}>{t('filters.noneActive', 'Keine Filter aktiv')}</li>
                )}
              </ul>
            </div>
          </div>
        </div>
    </Modal>
  );
};

export default TicketFilterModal; 